export default __webpack_public_path__ + "static/media/potato-21.b83cd6ac.png";